/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedFollowSearchBanner_user = {|
  +serviceId: ?string;
  +favorites: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedFollowSearchBanner_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages",
          "type": "[String]"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes",
          "type": "[types]"
        }
      ],
      "concreteType": "favoritesConnection",
      "name": "favorites",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowSearchButton_favoritesConnection",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
